import ReviewRouting from '../../../../banking/components/paycheck-routing/ReviewRouting';

export default function ReviewPaycheckRouting() {
    return <ReviewRouting />;
}
